module.exports = __webpack_public_path__ + "static/media/login.0348426c.png";